import { render, staticRenderFns } from "./IssueButton.vue?vue&type=template&id=102ddd3a&scoped=true&"
import script from "./IssueButton.vue?vue&type=script&lang=js&"
export * from "./IssueButton.vue?vue&type=script&lang=js&"
import style0 from "./IssueButton.vue?vue&type=style&index=0&id=102ddd3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102ddd3a",
  null
  
)

export default component.exports